import { Controller } from '@hotwired/stimulus';

// auto-submit form with select change.
export default class extends Controller {
  selectChange() {
    this.element.requestSubmit();
  }
}
